import { createSlice, current } from "@reduxjs/toolkit";
import { nestedTernaryCheckerCond1 } from "utils/CommonChecker";
import { sortableProperties } from "utils/CommonConstants";

const sortInitial: any = {
  plansSort_myList: {
    property: "planTitle",
    order: "asc"
  },
  propertiesSort_myList: { property: "inncode", order: "asc" },
  plansSort_dashboard: {
    property: "planTitle",
    order: "asc"
  },
  propertiesSort_dashboard: { property: "inncode", order: "asc" },
  adminConsole: { property: "lastLoggedInDate", order: "asc" },
  propertyPlan: { property: "title", order: "asc" },
  planProgressScreen: { property: "planCreatedDate", order: "asc" },
  propertyProgressScreen: { property: "planCreatedDate", order: "asc" },
  usersProgressScreen: { property: "planCreatedDate", order: "asc" },
  manageSuggestions: { property: "inncode", order: "asc" },
  feedbackForms: { property: "triggerPoint", order: "asc" }
};

const initialState: any = {
  sorting: sortInitial
};
function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

/**
 * Computes the next sort order for a given table's sort state, toggling
 * asc/desc when the same property is clicked again and defaulting to "asc"
 * when a different property is clicked. This is the single source of truth
 * for the sort-toggle behavior, used both by the `setSorting` reducer below
 * and by pages that need to predict the resulting order before it round-trips
 * through redux (e.g. to build an immediate API request payload).
 */
export function getNextSortOrder(currentSort: { property?: string; order?: string } | undefined, sortableType: string) {
  const isSameProperty = currentSort?.property === sortableType;
  const isCurrentlyAsc = currentSort?.order === "asc";
  return nestedTernaryCheckerCond1(isSameProperty, isCurrentlyAsc, "desc", "asc", "asc");
}

export const SortingSlice = createSlice({
  name: "sorting_slice",
  initialState,
  reducers: {
    reset: () => initialState,
    setSorting: (state, action) => {
      const { tableName, header, key } = action.payload;
      const sortableType = key ?? sortableProperties[header];
      state.sorting[tableName] = {
        property: sortableType,
        order: getNextSortOrder(current(state.sorting[tableName]), sortableType)
      };
    },
    resetSorting: (state, action) => {
      const { tableName } = action.payload;
      state.sorting[tableName] = sortInitial[tableName];
    },
    resetAllSorting: (state, action) => {
      state.sorting = sortInitial;
    },
    setSortingForSpecificCase: (state, action) => {
      state.sorting.propertyPlan = action?.payload?.reset ? { property: "title", order: "asc" } : {};
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(isRejectedAction, (state, action) => {});
  }
});
export const { reset, setSorting, resetSorting, resetAllSorting, setSortingForSpecificCase } = SortingSlice.actions;
export default SortingSlice.reducer;
